// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section-header[data-v-3faf44fe]{padding-bottom:15px;margin-bottom:15px;border-bottom:1px solid #e8eaec}.section-header .error-text[data-v-3faf44fe]{color:red}", ""]);
// Exports
module.exports = exports;
